import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, take } from 'rxjs';
import { DownloadPanelComponent } from './shared/components/download-panel.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, DownloadPanelComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'Compass AI';

  constructor(private router: Router) {}

  ngOnInit() {
    // Wait for router to complete initial navigation before checking for redirect
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      take(1)
    ).subscribe(() => {
      // Check if this is a hard refresh
      const navigationEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
      const isHardRefresh = navigationEntry &&
                            (navigationEntry.type === 'reload' ||
                             navigationEntry.type === 'navigate' &&
                             !sessionStorage.getItem('kore_initialized'));

      // Set a flag in session storage to track initialization
      sessionStorage.setItem('kore_initialized', 'true');

      // Redirect from /team/ routes on hard refresh
      if (isHardRefresh && window.location.pathname.includes('/team/')) {
        this.router.navigate(['/agents']);
      }
    });
  }
}
